import Dashboard from "..";

/** Dashboard → Usage sub-page: DAU, message volume, endpoints, skills and the all-skills table. */
const DashboardUsage = () => <Dashboard section="usage" />;

export default DashboardUsage;
